import type { ComboBoxType, RemoteMethod } from './combobox.type'
import { PropType } from 'vue'

const COMBO_TYPES = ['default', 'enum', 'data', 'demand']

export default {
  // v-model
  modelValue: [Array, Number, String, Boolean],

  // Kiểu combo (default|enum|data|demand)
  type: {
    type: String as PropType<ComboBoxType>,
    default: 'default',
    validator (type: ComboBoxType) {
      return COMBO_TYPES.indexOf(type) > -1
    }
  },

  // Hiển thị trên nhiều dòng
  multiline: {
    type: Boolean,
    default: false
  },

  // Cho phép chọn nhiều
  multiple: {
    type: Boolean,
    default: false
  },

  /**
   * Value field binding
   */
  valueField: {
    type: String,
    default: 'value'
  },

  /**
   * Field hiển thị
   */
  displayField: {
    type: String,
    default: 'display'
  },

  /**
   * Field hiển thị
   */
  classOption: {
    type: String,
    default: 'option'
  },

  /**
   * Dữ liệu của combobox
   */
  items: {
    default: () => [],
    type: Array
  },

  /**
   * Config template cho dropdown dạng multi column
   */
  columns: {
    type: Array,
    default: () => []
  },

  /**
   * Tên enum
   */
  enumName: {
    type: String,
    default: undefined
  },

  /**
   * Các key include của enum
   */
  includeKeys: {
    type: Array,
    default: () => []
  },

  /**
   * Các trường filter bổ sung
   */
  customFilterFields: {
    type: Array,
    default: () => []
  },

  /**
   * Index bản ghi tự động chọn
   */
  selectedIndex: {
    type: Number,
    default: -1
  },

  // URL get dữ liệu, áp dụng type = data và demand
  getDataUrl: {
    type: String,
    default: '',
    validator (val: any) {
      return typeof val === 'string'
    }
  },

  // Params truyền lên lấy dữ liệu khi sử dụng combobodata
  params: {
    type: Function,
    default: null
  },

  // Method lấy dữ liệu, mặc định là GET
  method: {
    type: String,
    default: 'GET',
    validator (val: string) {
      return ['GET', 'POST'].indexOf(val.toUpperCase()) > -1
    }
  },

  // Không cho phép gõ
  forceSelection: {
    type: Boolean,
    default: false
  },

  // Đang tải
  loading: {
    type: Boolean,
    default: false
  },

  // Inline style của option
  optionInlineStyle: {
    type: String,
    default: ''
  },

  // remote server
  remote: {
    type: Boolean,
    default: false
  },

  //
  remoteType: {
    type: String as PropType<RemoteMethod>,
    default: 'online'
  },

  sameWidth: {
    type: Boolean,
    default: true
  }
}
